import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import S from './Dropdown.styled'
import { DropdownProvider } from './DropdownContext'
import DropdownTrigger from './items/Trigger'
import DropdownTriggerIcon from './items/TriggerIcon'
import DropdownTriggerTitle from './items/TriggerTitle'
import DropdownContent from './items/Content'
import DropdownSection from './items/Section'
import DropdownSectionTitle from './items/SectionTitle'
import DropdownMobileButton from './items/MobileButton'
import DropdownRadioOption from './items/RadioOption'
import DropdownTextOption from './items/TextOption'
import DropdownCheckboxOption from './items/CheckboxOption'

const Dropdown = ({
  className,
  children,
  mobileHeading,
  alignContent = 'right',
  contentPosition = 'bottom',
  themeColor = 'dark',
}) => {
  const dropdownRef = useRef(null)

  return (
    <DropdownProvider
      ref={dropdownRef}
      mobileHeading={mobileHeading}
      alignContent={alignContent}
      contentPosition={contentPosition}
      themeColor={themeColor}
    >
      <S.Dropdown ref={dropdownRef} className={className}>
        {children}
      </S.Dropdown>
    </DropdownProvider>
  )
}

Dropdown.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  mobileHeading: PropTypes.string,
  alignContent: PropTypes.string,
  contentPosition: PropTypes.string,
  themeColor: PropTypes.string,
}

const Trigger = (props) => <DropdownTrigger {...props} />
Dropdown.Trigger = Trigger

const TriggerIcon = (props) => <DropdownTriggerIcon {...props} />
Dropdown.TriggerIcon = TriggerIcon

const TriggerTitle = (props) => <DropdownTriggerTitle {...props} />
Dropdown.TriggerTitle = TriggerTitle

const Content = (props) => <DropdownContent {...props} />
Dropdown.Content = Content

const Section = (props) => <DropdownSection {...props} />
Dropdown.Section = Section

const SectionTitle = (props) => <DropdownSectionTitle {...props} />
Dropdown.SectionTitle = SectionTitle

const MobileButton = (props) => <DropdownMobileButton {...props} />
Dropdown.MobileButton = MobileButton

const RadioOption = (props) => <DropdownRadioOption {...props} />
Dropdown.RadioOption = RadioOption

const TextOption = (props) => <DropdownTextOption {...props} />
Dropdown.TextOption = TextOption

const CheckboxOption = (props) => <DropdownCheckboxOption {...props} />
Dropdown.CheckboxOption = CheckboxOption

export default Dropdown
